module.exports = __webpack_public_path__ + "img/cover.b4dc1c0b.jpg";